import { RowData } from "@models/DataTable"

export interface IRowCompany {
  businessName: string
  legalName: string
  description?: string
  phone?: string
  emailAddress?: string
  website?: string
  vatCode?: string
  parentId?: number
  parentBusinessName?: string
  parentLegalName?: string
  leadSourceName?: string
}

export class RowCompanyModel extends RowData implements IRowCompany {
  // id?: number
  // name?: string
  businessName: string
  legalName: string
  constructor() {
    super()
    this.businessName = ""
    this.legalName = ""
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new RowCompanyModel(), obj)

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class CompanyDetailModel extends RowData {
  parent: any
  companyTypeMapIds: any[]
  companyTypeMap: any[]
  licenseIssuedDate: any
  constructor() {
    super()
    this.companyTypeMapIds = []
    this.companyTypeMap = []
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new RowCompanyModel(), obj)

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export interface ICompanyItemModel {
  id?: number
  contactId?: number
  companyId?: number
  title?: string
  businessName?: string
  isPrimary?: boolean
  isActive?: boolean
}

export class CompanyItemModel {
  id?: number
  contactId?: number
  companyId?: number
  title?: string
  businessName?: string
  isPrimary?: boolean
  isActive?: boolean

  constructor(isPrimary?) {
    this.isPrimary = isPrimary
  }
}
